import React, { useEffect, useState } from 'react';
import { LinearProgress, Paper, TextField, Typography, withStyles } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { ResponsiveBar, ResponsiveBarCanvas } from '@nivo/bar'
import { ResponsivePie } from '@nivo/pie'
import ReactECharts from 'echarts-for-react';
import api from './api';
import Constant from '../library/Constant';

const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 20,
        borderRadius: 10,
    },
    colorPrimary: {
        backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        borderRadius: 10,
        backgroundColor: '#49ea6e',
    },
}))(LinearProgress);

const BorderLinearProgressKiosk = withStyles((theme) => ({
    root: {
        height: 20,
        borderRadius: 10,
    },
    colorPrimary: {
        backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        borderRadius: 10,
        backgroundColor: "#3aecb1",
    },
}))(LinearProgress);

const BorderLinearProgressWeb = withStyles((theme) => ({
    root: {
        height: 20,
        borderRadius: 10,
    },
    colorPrimary: {
        backgroundColor: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
    },
    bar: {
        borderRadius: 10,
        backgroundColor: "#278863",
    },
}))(LinearProgress);

export default function DashboardTransaksi(props) {
    // console.log(props);
    // const option = {
    //     title: {
    //         text: 'Rata-Rata Usia',
    //         textStyle: {
    //             color: '#2a9c6c',
    //             fontFamily: 'Poppins',
    //             fontSize: 22
    //         }
    //     },
    //     tooltip: {
    //         trigger: 'axis',
    //         axisPointer: {            // 坐标轴指示器，坐标轴触发有效
    //             type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
    //         }
    //     },
    //     grid: {
    //         left: '3%',
    //         right: '4%',
    //         bottom: '3%',
    //         containLabel: true
    //     },
    //     xAxis: [
    //         {
    //             type: 'category',
    //             data: ['< 5', '5-10', '10-20', '20-30', '30-40', '40-50', '50-60', '60-70', '70-80', '80-90', '> 90'],
    //             axisTick: {
    //                 alignWithLabel: true
    //             }
    //         }
    //     ],
    //     yAxis: [
    //         {
    //             type: 'value'
    //         }
    //     ],
    //     series: [
    //         {
    //             name: 'Rata-rata usia',
    //             type: 'bar',
    //             barWidth: '30%',
    //             data: [50, 80, 100, 250, 260, 290, 200, 150, 60, 30, 10],
    //             color: '#3aecb1'
    //         }
    //     ]
    // };
    const [option, setOption] = useState(null)
    const [optionPie, setOptionPie] = useState(null)

    // const optionPie = {
    //     title: {
    //         text: 'Jenis Kelamin',
    //         textStyle: {
    //             color: '#2a9c6c',
    //             fontFamily: 'Poppins',
    //             fontSize: 22
    //         }
    //     },
    //     tooltip: {
    //         trigger: 'item'
    //     },
    //     legend: {
    //         bottom: '5%',
    //         left: 'center'
    //     },
    //     textStyle: {
    //         fontFamily: 'Poppins'
    //     },
    //     series: [
    //         {
    //             name: 'Jenis Kelamin',
    //             type: 'pie',
    //             radius: ['40%', '70%'],
    //             avoidLabelOverlap: false,
    //             itemStyle: {
    //                 borderRadius: 10,
    //                 borderColor: '#fff',
    //                 borderWidth: 2
    //             },
    //             color: [
    //                 "#278863",
    //                 "#8bf0c5",
    //             ],
    //             label: {
    //                 show: false,
    //                 position: 'center',
    //                 // formatter: '{d}%',
    //                 // fontSize: '20',
    //                 // fontWeight: 'bold',
    //                 // fontFamily: 'Poppins'
    //             },
    //             // avoidLabelOverlap: false,
    //             emphasis: {
    //                 label: {
    //                     show: true,
    //                     fontSize: '28',
    //                     fontWeight: 'bold',
    //                     formatter: '{d}%',
    //                     fontFamily: 'Poppins'
    //                 }
    //             },
    //             labelLine: {
    //                 show: false
    //             },
    //             data: [
    //                 { value: 80, name: 'Laki-Laki', color: '#278863' },
    //                 { value: 20, name: 'Perempuan', color: '#8bf0c5' },
    //             ]
    //         }
    //     ]
    // };

    const [data, setData] = useState([])
    const [totalReservasi, setTotalReservasi] = useState("")
    const [valueReservasi, setValueReservasi] = useState(null)
    const [valueCheckin, setValueCheckin] = useState(null)
    const [pembayaran, setPembayaran] = useState(null)
    const [pasienBatal, setPasienBatal] = useState(null)
    const [pasienReschedule, setPasienReschedule] = useState(null)
    const [pasienCheckin, setPasienCheckIn] = useState([])
    const [pasienReservasi, setPasienReservasi] = useState([])
    const [loading, setLoading] = useState(false)

    const forceUpdate = React.useReducer(bool => !bool)[1];


    useEffect(() => {
        getData()
        console.log(props);
    }, [])

    const getData = () => {
        api.create().getDashboardTransaksi(props.month.id, props.year.nama).then(response => {
            console.log(response);
            if (response.data) {
                if (response.status === 200) {
                    let data = response.data
                    setPembayaran(data.total_payment)
                    setPasienBatal(data.patient_cancel)
                    setPasienReschedule(data.patient_reschedule)
                    setPasienCheckIn(data.total_patient_checkin)
                    setPasienReservasi(data.total_reservation)
                    setTotalReservasi(data.total_patient_reservation)
                    let valReservasi = 0
                    if (data.total_reservation.length > 0) {
                        data.total_reservation.map((item) => {
                            if (String(item.reservation_from).toUpperCase() !== "OTHER") {
                                valReservasi = valReservasi + item.total_patient
                            }
                        })
                    }
                    let valCheckin = 0
                    if (data.total_patient_checkin.length > 0) {
                        data.total_patient_checkin.map((item) => {
                            if (String(item.reservation_from).toUpperCase() !== "OTHER") {
                                valCheckin = valCheckin + item.total_patient
                            }
                        })
                    }
                    // console.log(valReservasi);
                    setValueReservasi(valReservasi)
                    setValueCheckin(valCheckin)

                    let usiaA = []
                    let usiaB = []
                    response.data.patient_age_average.map((item, index) => {
                        usiaA.push(item.range_age)
                        usiaB.push(item.total_patient)
                    })

                    let dataUsia = {
                        title: {
                            text: 'Rata-Rata Usia',
                            textStyle: {
                                color: '#2a9c6c', fontSize: 22, fontFamily: 'Poppins', fontWeight: '500'
                            }
                        },
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                                type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                            }
                        },
                        grid: {
                            left: '3%',
                            right: '4%',
                            bottom: '3%',
                            containLabel: true
                        },
                        xAxis: [
                            {
                                type: 'category',
                                data: usiaA,
                                axisTick: {
                                    alignWithLabel: true
                                }
                            }
                        ],
                        yAxis: [
                            {
                                type: 'value'
                            }
                        ],
                        series: [
                            {
                                name: 'Total Pasien',
                                type: 'bar',
                                barWidth: '30%',
                                data: usiaB,
                                color: '#3aecb1'
                            }
                        ]
                    };

                    let genderA = []
                    let genderB = []
                    response.data.patient_gender.map((item, index) => {
                        genderA.push({
                            value: item.total_patient,
                            name: item.gender,
                            color: index === 0 ? '#278863' : '#8bf0c5'
                        })
                    })

                    let dataGender = {
                        title: {
                            text: 'Jenis Kelamin',
                            textStyle: {
                                color: '#2a9c6c', fontSize: 22, fontFamily: 'Poppins', fontWeight: '500'
                            }
                        },
                        tooltip: {
                            trigger: 'item'
                        },
                        legend: {
                            bottom: '5%',
                            left: 'center'
                        },
                        textStyle: {
                            fontFamily: 'Poppins'
                        },
                        series: [
                            {
                                name: 'Jenis Kelamin',
                                type: 'pie',
                                radius: ['40%', '70%'],
                                avoidLabelOverlap: false,
                                itemStyle: {
                                    borderRadius: 10,
                                    borderColor: '#fff',
                                    borderWidth: 2
                                },
                                color: [
                                    "#278863",
                                    "#8bf0c5",
                                ],
                                label: {
                                    show: false,
                                    position: 'center',
                                    // formatter: '{d}%',
                                    // fontSize: '20',
                                    // fontWeight: 'bold',
                                    // fontFamily: 'Poppins'
                                },
                                // avoidLabelOverlap: false,
                                emphasis: {
                                    label: {
                                        show: true,
                                        fontSize: '28',
                                        fontWeight: 'bold',
                                        formatter: '{d}%',
                                        fontFamily: 'Poppins'
                                    }
                                },
                                labelLine: {
                                    show: false
                                },
                                data: genderA
                            }
                        ]
                    };

                    setOptionPie(dataGender)

                    setOption(dataUsia)

                    setLoading(true)
                    forceUpdate()
                } else {
                    localStorage.removeItem(Constant.token)
                    localStorage.removeItem(Constant.ACCESS_TOKEN)
                    localStorage.removeItem(Constant.REFRESH_TOKEN)
                    window.location.reload();
                }
            }
        })
    }

    const numberWithCommas = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    return (
        <div style={{ marginTop: 20, }}>
            {loading && (
                <div style={{ maxHeight: props.height - 140, display: 'grid', overflow: 'scroll', }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', paddingLeft: 20, paddingRight: 20 }}>
                        <Paper style={{ height: 220, width: '24%', borderRadius: 20, boxShadow: '8px 8px 16px 0 rgba(55, 55, 55, 0.2)' }}>
                            <div style={{ padding: '10px 20px' }}>
                                <Typography style={{ color: '#2a9c6c', fontSize: 22, fontFamily: 'Poppins', fontWeight: '500' }}>Pasien Batal</Typography>
                            </div>
                            <div style={{ padding: '1vw 2vw', display: 'flex', justifyContent: 'space-evenly' }}>
                                <div style={{ display: 'grid', justifyItems: 'center' }}>
                                    <Typography style={{ color: '#2a9c6c', fontSize: 20 }}>Mobile</Typography>
                                    <Typography style={{ color: '#2a9c6c', fontSize: 40 }}>{pasienBatal.mobile}</Typography>
                                </div>
                                <div style={{ display: 'grid', justifyItems: 'center' }}>
                                    <Typography style={{ color: '#2a9c6c', fontSize: 20 }}>Kiosk</Typography>
                                    <Typography style={{ color: '#2a9c6c', fontSize: 40 }}>{pasienBatal.kiosk}</Typography>
                                </div>
                            </div>
                        </Paper>
                        <Paper style={{ height: 220, width: '24%', borderRadius: 20, boxShadow: '8px 8px 16px 0 rgba(55, 55, 55, 0.2)' }} >
                            <div style={{ padding: '10px 20px' }}>
                                <Typography style={{ color: '#2a9c6c', fontSize: 22, fontFamily: 'Poppins', fontWeight: '500' }}>Perubahan Jadwal Pasien</Typography>
                            </div>
                            <div style={{ padding: '1vw 2vw', display: 'flex', justifyContent: 'space-evenly' }}>
                                <div style={{ display: 'grid', justifyItems: 'center' }}>
                                    <Typography style={{ color: '#2a9c6c', fontSize: 20 }}>Mobile</Typography>
                                    <Typography style={{ color: '#2a9c6c', fontSize: 40 }}>{pasienReschedule.mobile}</Typography>
                                </div>
                                <div style={{ display: 'grid', justifyItems: 'center' }}>
                                    <Typography style={{ color: '#2a9c6c', fontSize: 20 }}>Kiosk</Typography>
                                    <Typography style={{ color: '#2a9c6c', fontSize: 40 }}>{pasienReschedule.kiosk}</Typography>
                                </div>
                            </div>
                        </Paper>
                        <Paper style={{ height: 220, width: '24%', borderRadius: 20, boxShadow: '8px 8px 16px 0 rgba(55, 55, 55, 0.2)' }} >
                            <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                                <Typography style={{ color: '#2a9c6c', fontSize: 22, fontFamily: 'Poppins', fontWeight: '500' }}>Total Reservasi</Typography>
                            </div>
                            <div style={{ display: 'grid', justifyItems: 'center', padding: '10px 20px' }}>
                                <Typography style={{ color: '#2a9c6c', fontSize: 70 }}>{totalReservasi}</Typography>
                            </div>
                        </Paper>
                        <Paper style={{ height: 220, width: '24%', borderRadius: 20, boxShadow: '8px 8px 16px 0 rgba(55, 55, 55, 0.2)' }} >
                            <div style={{ paddingTop: 10, paddingLeft: 20 }}>
                                <Typography style={{ color: '#2a9c6c', fontSize: 22, fontFamily: 'Poppins', fontWeight: '500' }}>Total Pembayaran</Typography>
                            </div>
                            <div style={{ display: 'grid', marginTop: 10 }}>
                                {/* {props.width < 2200 ? */}
                                    <div style={{ padding: '1vh 3vh', width: props.open ? '92%' : '100%' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                            <Typography style={{ color: '#868686', fontSize: 14, fontFamily: 'Poppins' }}>Tunai</Typography>
                                            <Typography style={{ color: '#2a9c6c', fontSize: 14, fontFamily: 'Poppins', fontWeight: '500' }}>Rp.{numberWithCommas(pembayaran.cash)}</Typography>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '.5vw' }}>
                                            <Typography style={{ color: '#868686', fontSize: 14, fontFamily: 'Poppins' }}>Transfer/Debit</Typography>
                                            <Typography style={{ color: '#2a9c6c', fontSize: 14, fontFamily: 'Poppins', fontWeight: '500' }}>Rp.{numberWithCommas(pembayaran.debit_transfer)}</Typography>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '.5vw' }}>
                                            <Typography style={{ color: '#868686', fontSize: 14, fontFamily: 'Poppins' }}>Kartu Kredit</Typography>
                                            <Typography style={{ color: '#2a9c6c', fontSize: 14, fontFamily: 'Poppins', fontWeight: '500' }}>Rp.{numberWithCommas(pembayaran.credit_card)}</Typography>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '.5vw' }}>
                                            <Typography style={{ color: '#868686', fontSize: 14, fontFamily: 'Poppins' }}>E-Money</Typography>
                                            <Typography style={{ color: '#2a9c6c', fontSize: 14, fontFamily: 'Poppins', fontWeight: '500' }}>Rp.{numberWithCommas(pembayaran.e_money)}</Typography>
                                        </div>
                                    </div> 
                                    {/* :
                                    <div style={{}}>
                                        <div className="grid grid-2x grid-mobile-none" style={{ padding: '3vh' }}>
                                            <div className="column-1">
                                                <Typography style={{ color: '#868686', fontSize: '1.2vw' }}>Tunai</Typography>
                                                <Typography style={{ color: '#868686', fontSize: '1.2vw', marginTop: '.2vw' }}>EMoney</Typography>
                                                <Typography style={{ color: '#868686', fontSize: '1.2vw', marginTop: '.2vw' }}>Kartu Debit</Typography>
                                                <Typography style={{ color: '#868686', fontSize: '1.2vw', marginTop: '.2vw' }}>Kartu Kredit</Typography>
                                                <Typography style={{ color: '#868686', fontSize: '1.2vw', marginTop: '.2vw' }}>Virtual Account</Typography>
                                            </div>
                                            <div className="column-2">
                                                <Typography style={{ color: '#2a9c6c', fontSize: '1.2vw', textAlign: 'right' }}>Rp.10.000.000</Typography>
                                                <Typography style={{ color: '#2a9c6c', fontSize: '1.2vw', marginTop: '.2vw', textAlign: 'right' }}>Rp.8.000.000</Typography>
                                                <Typography style={{ color: '#2a9c6c', fontSize: '1.2vw', marginTop: '.2vw', textAlign: 'right' }}>Rp.8.000.000</Typography>
                                                <Typography style={{ color: '#2a9c6c', fontSize: '1.2vw', marginTop: '.2vw', textAlign: 'right' }}>Rp.8.000.000</Typography>
                                                <Typography style={{ color: '#2a9c6c', fontSize: '1.2vw', marginTop: '.2vw', textAlign: 'right' }}>Rp.8.000.000</Typography>
                                            </div>
                                        </div>
                                    </div>
                                } */}
                            </div>
                        </Paper>
                    </div>
                    <div style={{ marginTop: 20, display: 'flex', justifyContent: 'space-between', paddingLeft: 20, paddingRight: 20 }}>
                        <Paper style={{ height: 400, width: '69%', borderRadius: 20, boxShadow: '8px 8px 16px 0 rgba(55, 55, 55, 0.2)', display: 'flex', justifyContent: 'center' }} >
                            <ReactECharts
                                style={{ height: 370, width: '95%', marginTop: 10 }}
                                option={option}
                            />
                        </Paper>
                        <Paper style={{ height: 400, width: '29%', borderRadius: 20, boxShadow: '8px 8px 16px 0 rgba(55, 55, 55, 0.2)', display: 'flex', justifyContent: 'center' }} >
                            <ReactECharts
                                style={{ height: 375, width: '95%', marginTop: 10 }}
                                option={optionPie}
                            />
                        </Paper>
                    </div>
                    <div style={{ marginTop: 20, display: 'flex', justifyContent: 'space-between', paddingLeft: 20, paddingRight: 20, paddingBottom: 20 }}>
                        <Paper style={{ width: '49%', borderRadius: 20, boxShadow: '8px 8px 16px 0 rgba(55, 55, 55, 0.2)' }} >
                            <div style={{ paddingLeft: 20, paddingTop: 10 }}>
                                <Typography style={{ color: '#2a9c6c', fontSize: 22, fontFamily: 'Poppins', fontWeight: '500' }}>Total Check In</Typography>
                            </div>
                            {pasienCheckin && pasienCheckin.map((item, index) => {
                                if (String(item.reservation_from).toUpperCase() === "OTHER") {
                                    return null
                                } else {
                                    return (
                                        <div style={{ padding: '20px 25px 0px 25px' }}>
                                            {String(item.reservation_from).toUpperCase() === "MOBILE" ?
                                                <BorderLinearProgress variant="determinate" value={(item.total_patient / valueCheckin) * 100} />
                                                : String(item.reservation_from).toUpperCase() === "WEB ADMIN" ?
                                                    <BorderLinearProgressKiosk variant="determinate" value={(item.total_patient / valueCheckin) * 100} />
                                                    :
                                                    <BorderLinearProgressWeb variant="determinate" value={(item.total_patient / valueCheckin) * 100} />
                                            }
                                        </div>
                                    )
                                }
                            })}

                            {/* <div style={{ padding: '20px 25px' }}>
                                <BorderLinearProgressKiosk variant="determinate" value={40} />
                            </div>
                            <div style={{ padding: '0px 25px' }}>
                                <BorderLinearProgressWeb variant="determinate" value={50} />
                            </div> */}

                            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 20 }}>
                                {pasienCheckin && pasienCheckin.map((item, index) => {
                                    if (String(item.reservation_from).toUpperCase() === "OTHER") {
                                        return null
                                    } else {
                                        return (
                                            <div style={{ marginLeft: index === 0 ? 0 : 30 }}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div style={{ backgroundColor: String(item.reservation_from).toUpperCase() === "MOBILE" ? '#49ea6e' : String(item.reservation_from).toUpperCase() === "WEB ADMIN" ? '#3aecb1' : '#278863', width: 40, height: 15, borderRadius: 10, marginRight: 20 }} />
                                                    <Typography style={{ color: '#acacac', fontSize: 16 }}>{item.reservation_from}</Typography>
                                                </div>
                                                <Typography style={{ color: 'black', fontSize: 18, fontWeight: '500', textAlign: 'right' }}>{item.total_patient} Pasien</Typography>
                                            </div>
                                        )
                                    }
                                })}
                            </div>

                            {/* <div style={{ marginRight: 30 }}>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div style={{ backgroundColor: "#3aecb1", width: 40, height: 15, borderRadius: 10, marginRight: 20 }} />
                                            <Typography style={{ color: '#acacac', fontSize: 16 }}>Kiosk</Typography>
                                        </div>
                                        <Typography style={{ color: 'black', fontSize: 18, fontWeight: '500', textAlign: 'right' }}>40 Pasien</Typography>
                                    </div>
                                    <div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div style={{ backgroundColor: "#278863", width: 40, height: 15, borderRadius: 10, marginRight: 20 }} />
                                            <Typography style={{ color: '#acacac', fontSize: 16 }}>Web Admin</Typography>
                                        </div>
                                        <Typography style={{ color: 'black', fontSize: 18, fontWeight: '500', textAlign: 'right' }}>50 Pasien</Typography>
                                    </div> */}
                        </Paper>
                        <Paper style={{ width: '49%', borderRadius: 20, boxShadow: '8px 8px 16px 0 rgba(55, 55, 55, 0.2)' }} >
                            <div style={{ paddingLeft: 20, paddingTop: 10 }}>
                                <Typography style={{ color: '#2a9c6c', fontSize: 22, fontFamily: 'Poppins', fontWeight: '500' }}>Total Reservasi</Typography>
                            </div>
                            {pasienReservasi && pasienReservasi.map((item, index) => {
                                if (String(item.reservation_from).toUpperCase() === "OTHER") {
                                    return null
                                } else {
                                    return (
                                        <div style={{ padding: '20px 25px 0px 25px' }}>
                                            {String(item.reservation_from).toUpperCase() === "MOBILE" ?
                                                <BorderLinearProgress variant="determinate" value={(item.total_patient / valueReservasi) * 100} />
                                                : String(item.reservation_from).toUpperCase() === "WEB ADMIN" ?
                                                    <BorderLinearProgressKiosk variant="determinate" value={(item.total_patient / valueReservasi) * 100} />
                                                    :
                                                    <BorderLinearProgressWeb variant="determinate" value={(item.total_patient / valueReservasi) * 100} />
                                            }
                                        </div>
                                    )
                                }
                            })}

                            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 20 }}>
                                {pasienReservasi && pasienReservasi.map((item, index) => {
                                    if (String(item.reservation_from).toUpperCase() === "OTHER") {
                                        return null
                                    } else {
                                        return (
                                            <div style={{ marginLeft: index === 0 ? 0 : 30 }}>
                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                    <div style={{ backgroundColor: String(item.reservation_from).toUpperCase() === "MOBILE" ? '#49ea6e' : String(item.reservation_from).toUpperCase() === "WEB ADMIN" ? '#3aecb1' : '#278863', width: 40, height: 15, borderRadius: 10, marginRight: 20 }} />
                                                    <Typography style={{ color: '#acacac', fontSize: 16 }}>{item.reservation_from}</Typography>
                                                </div>
                                                <Typography style={{ color: 'black', fontSize: 18, fontWeight: '500', textAlign: 'right' }}>{item.total_patient} Pasien</Typography>
                                            </div>
                                        )
                                    }
                                })}
                            </div>
                            {/* <div style={{ padding: '20px 25px 0px 25px' }}>
                                <BorderLinearProgress variant="determinate" value={80} />
                            </div>
                            <div style={{ padding: '20px 25px' }}>
                                <BorderLinearProgressKiosk variant="determinate" value={40} />
                            </div>
                            <div style={{ padding: '0px 25px' }}>
                                <BorderLinearProgressWeb variant="determinate" value={30} />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 20 }}>
                                <div style={{ marginRight: 30 }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div style={{ backgroundColor: '#49ea6e', width: 40, height: 15, borderRadius: 10, marginRight: 20 }} />
                                        <Typography style={{ color: '#acacac', fontSize: 16 }}>Mobile</Typography>
                                    </div>
                                    <Typography style={{ color: 'black', fontSize: 18, fontWeight: '500', textAlign: 'right' }}>80 Pasien</Typography>
                                </div>
                                <div style={{ marginRight: 30 }}>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div style={{ backgroundColor: "#3aecb1", width: 40, height: 15, borderRadius: 10, marginRight: 20 }} />
                                        <Typography style={{ color: '#acacac', fontSize: 16 }}>Kiosk</Typography>
                                    </div>
                                    <Typography style={{ color: 'black', fontSize: 18, fontWeight: '500', textAlign: 'right' }}>40 Pasien</Typography>
                                </div>
                                <div>
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div style={{ backgroundColor: "#278863", width: 40, height: 15, borderRadius: 10, marginRight: 20 }} />
                                        <Typography style={{ color: '#acacac', fontSize: 16 }}>Web Admin</Typography>
                                    </div>
                                    <Typography style={{ color: 'black', fontSize: 18, fontWeight: '500', textAlign: 'right' }}>30 Pasien</Typography>
                                </div>
                            </div> */}
                        </Paper>
                    </div>
                </div>
            )}
        </div>
    );
}